"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var fabric_1 = require("fabric");
var Base_1 = __importDefault(require("./Base"));
var drawer_1 = require("../utils/drawer");
var Personalization = /** @class */ (function (_super) {
    __extends(Personalization, _super);
    function Personalization(props) {
        var _this = _super.call(this, props) || this;
        _this.init();
        return _this;
    }
    Personalization.prototype.init = function () {
        var _this = this;
        var rotationControlPosition = {
            y: this.config.controlsPosition.rotation === "TOP" ? -0.5 : 0.5,
            offsetY: this.config.controlsPosition.rotation === "TOP" ? -30 : 30,
        };
        //Disable context menu
        //@ts-ignore
        fabric_1.fabric.util.addListener(document.getElementsByClassName("upper-canvas")[0], "contextmenu", function (e) {
            e.preventDefault();
        });
        fabric_1.fabric.Object.prototype.transparentCorners = false;
        fabric_1.fabric.Object.prototype.cornerColor = "#20bf6b";
        fabric_1.fabric.Object.prototype.cornerStyle = "circle";
        fabric_1.fabric.Object.prototype.borderColor = "#3782F7";
        fabric_1.fabric.Object.prototype.cornerSize = 12;
        fabric_1.fabric.Object.prototype.borderScaleFactor = 2.25;
        fabric_1.fabric.Object.prototype.borderOpacityWhenMoving = 1;
        fabric_1.fabric.Object.prototype.borderOpacity = 1;
        fabric_1.fabric.Object.prototype.controls.tr = new fabric_1.fabric.Control({
            x: 0.5,
            y: -0.5,
            actionHandler: fabric_1.fabric.controlsUtils.scalingEqually,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: fabric_1.fabric.controlsUtils.scaleOrSkewActionName,
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Object.prototype.controls.tl = new fabric_1.fabric.Control({
            x: -0.5,
            y: -0.5,
            actionHandler: fabric_1.fabric.controlsUtils.scalingEqually,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: fabric_1.fabric.controlsUtils.scaleOrSkewActionName,
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Object.prototype.controls.bl = new fabric_1.fabric.Control({
            x: -0.5,
            y: 0.5,
            actionHandler: fabric_1.fabric.controlsUtils.scalingEqually,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: fabric_1.fabric.controlsUtils.scaleOrSkewActionName,
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Object.prototype.controls.br = new fabric_1.fabric.Control({
            x: 0.5,
            y: 0.5,
            actionHandler: fabric_1.fabric.controlsUtils.scalingEqually,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: fabric_1.fabric.controlsUtils.scaleOrSkewActionName,
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Object.prototype.controls.ml = new fabric_1.fabric.Control({
            x: -0.5,
            y: 0,
            actionHandler: fabric_1.fabric.controlsUtils.scalingXOrSkewingY,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: fabric_1.fabric.controlsUtils.scaleOrSkewActionName,
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Object.prototype.controls.mt = new fabric_1.fabric.Control({
            x: 0,
            y: -0.5,
            actionHandler: fabric_1.fabric.controlsUtils.scalingYOrSkewingX,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: fabric_1.fabric.controlsUtils.scaleOrSkewActionName,
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Object.prototype.controls.mb = new fabric_1.fabric.Control({
            x: 0,
            y: 0.5,
            actionHandler: fabric_1.fabric.controlsUtils.scalingYOrSkewingX,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: fabric_1.fabric.controlsUtils.scaleOrSkewActionName,
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Object.prototype.controls.mr = new fabric_1.fabric.Control({
            x: 0.5,
            y: 0,
            actionHandler: fabric_1.fabric.controlsUtils.scalingXOrSkewingY,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: fabric_1.fabric.controlsUtils.scaleOrSkewActionName,
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Object.prototype.controls.mtr = new fabric_1.fabric.Control(__assign({ x: 0, y: 0.5, offsetY: 30, actionHandler: fabric_1.fabric.controlsUtils.rotationWithSnapping, cursorStyleHandler: fabric_1.fabric.controlsUtils.rotationStyleHandler, actionName: "rotate", render: drawer_1.drawCircleIcon, cornerSize: 28, withConnection: true }, rotationControlPosition));
        // Texbox controls
        fabric_1.fabric.Textbox.prototype.controls.tr = fabric_1.fabric.Object.prototype.controls.tr;
        fabric_1.fabric.Textbox.prototype.controls.tl = fabric_1.fabric.Object.prototype.controls.tl;
        fabric_1.fabric.Textbox.prototype.controls.bl = fabric_1.fabric.Object.prototype.controls.bl;
        fabric_1.fabric.Textbox.prototype.controls.br = fabric_1.fabric.Object.prototype.controls.br;
        fabric_1.fabric.Textbox.prototype.controls.mt = new fabric_1.fabric.Control({
            render: function () { return true; },
        });
        fabric_1.fabric.Textbox.prototype.controls.mb = fabric_1.fabric.Textbox.prototype.controls.mt;
        fabric_1.fabric.Textbox.prototype.controls.mr = new fabric_1.fabric.Control({
            x: 0.5,
            y: 0,
            actionHandler: fabric_1.fabric.controlsUtils.changeWidth,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: "resizing",
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Textbox.prototype.controls.ml = new fabric_1.fabric.Control({
            x: -0.5,
            y: 0,
            actionHandler: fabric_1.fabric.controlsUtils.changeWidth,
            cursorStyleHandler: fabric_1.fabric.controlsUtils.scaleSkewCursorStyleHandler,
            actionName: "resizing",
            render: drawer_1.drawCircleIcon,
            cornerSize: 28,
            withConnection: true,
        });
        fabric_1.fabric.Textbox.prototype.controls.mtr = new fabric_1.fabric.Control(__assign({ x: 0, y: 0.5, offsetY: 30, actionHandler: fabric_1.fabric.controlsUtils.rotationWithSnapping, cursorStyleHandler: fabric_1.fabric.controlsUtils.rotationStyleHandler, actionName: "rotate", render: drawer_1.drawCircleIcon, cornerSize: 28, withConnection: true }, rotationControlPosition));
        this.canvas.selectionColor = "rgba(55, 130, 247, 0.15)";
        this.canvas.selectionBorderColor = "#3782F7";
        this.canvas.selectionLineWidth = 1.5;
        this.canvas.on("selection:created", function (ev) {
            var objects = _this.canvas.getActiveObjects();
            var selection = _this.canvas.getActiveObject();
            if (objects.length > 1) {
                selection.setControlsVisibility({
                    mt: false,
                    mb: false,
                    mr: false,
                    ml: false,
                });
                selection.padding = 10;
            }
        });
        this.canvas.on("mouse:over", function (event) {
            var target = event.target;
            var activeObjects = _this.canvas.getActiveObject();
            if (target && activeObjects !== target && target.type !== "Background" && target.type !== "BackgroundImage") {
                var bound = target.getBoundingRect();
                var ctx = _this.canvas.getContext();
                ctx.strokeStyle = "#3782F7";
                ctx.lineWidth = 2.25;
                ctx.strokeRect(bound.left, bound.top, bound.width, bound.height);
            }
        });
    };
    return Personalization;
}(Base_1.default));
exports.default = Personalization;
//# sourceMappingURL=Personalization.js.map